export class AppConfig {
  // public LOGIN_ENDPOINT = 'http://10.12.61.210:8002/user/';
  // public API_ENDPOINT = 'http://10.12.61.210:8002/portal/';
  // public API_ENDPOINT1 = 'http://10.12.61.210:8002/adminapp/';
  // public IMG_URL = 'http://10.12.61.210:8002/media/';
  // public QuizImg = 'http://10.12.61.210:8002';

  public LOGIN_ENDPOINT = 'https://api-prod.iquanta.in/user/';
  public API_ENDPOINT = 'https://api-prod.iquanta.in/portal/';
  public API_ENDPOINT1 = 'https://api-prod.iquanta.in/adminapp/';
  public IMG_URL = 'https://api-prod.iquanta.in/media/';
  public QuizImg = 'https://api-prod.iquanta.in';
  
}